export default __webpack_public_path__ + "static/media/112t.47b83e30.jpg";